import type { ReactNode } from 'react'

export const AgencyNotFoundView = (): ReactNode => (
  <div className="agency-detail-wrapper flex h-full items-center justify-center">
    <div className="text-center">
      <h2 className="text-xl font-semibold">Agency not found</h2>
      <p className="text-muted-foreground mt-2">The agency you are looking for does not exist.</p>
    </div>
  </div>
)
